module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/empty/empty.component.css
// module id = ./src/app/examples/empty/empty.component.css
// module chunks = main